import * as zExt from "@redotech/rpc/ext";
import * as z from "zod/v4";

export const deleteLocalizationGroup = {
  name: "deleteLocalizationGroup" as const,
  input: z.object({
    teamId: zExt.objectId(),
    localizationGroupId: zExt.objectId(),
  }),
  output: z.object({ success: z.boolean() }),
};
